import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Link } from "react-router-dom";

export function EstimateDialog({ pending, onCancel, onConfirm }) {
  const est = pending?.est;
  const enough = est && est.balance >= est.max_credits;
  return (
    <Dialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="bg-[#161C2E] border-[#222B40]" data-testid="estimate-dialog">
        <DialogHeader>
          <DialogTitle>Confirmar operación</DialogTitle>
          <DialogDescription>Los agentes calcularán el costo real al terminar. Nunca se cobrará más del máximo que autorices.</DialogDescription>
        </DialogHeader>
        {est && (
          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="rounded-xl border border-[#222B40] p-3"><p className="text-[11px] text-slate-500">Estimado</p><p className="font-display text-2xl text-white" data-testid="estimate-credits">{est.credits}</p></div>
            <div className="rounded-xl border border-cyan-500/40 p-3"><p className="text-[11px] text-slate-500">Máximo autorizado</p><p className="font-display text-2xl text-cyan-300" data-testid="estimate-max-credits">{est.max_credits}</p></div>
            <div className="rounded-xl border border-[#222B40] p-3"><p className="text-[11px] text-slate-500">Tu saldo</p><p className="font-display text-2xl text-white" data-testid="estimate-balance">{est.balance}</p></div>
          </div>
        )}
        {est?.limit_error && <p className="text-sm text-amber-300" data-testid="estimate-limit-error">{est.limit_error}</p>}
        {est && !enough && <p className="text-sm text-amber-300" data-testid="estimate-insufficient">Saldo insuficiente para autorizar esta operación. <Link to="/app/creditos" className="underline">Comprar créditos</Link></p>}
        <p className="text-[11px] text-slate-500">Modelo: {est?.model} · ≈{est?.tokens.input.toLocaleString()} tokens de entrada / {est?.tokens.output.toLocaleString()} de salida (estimación)</p>
        <DialogFooter>
          <button onClick={onCancel} className="px-4 py-2 rounded-lg border border-[#222B40] text-slate-300 text-sm" data-testid="estimate-cancel-btn">Cancelar</button>
          <button onClick={() => onConfirm(pending.msg, est.max_credits)} disabled={!enough || !!est?.limit_error} data-testid="estimate-confirm-btn"
            className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-400 disabled:opacity-40 text-white text-sm">Autorizar y enviar</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
